// Chakra Imports
import {
  Avatar,
  AvatarBadge,
  Button,
  Flex,
  Icon,
  IconButton,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spinner,
  Stack,
  Text,
  useColorMode,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
// Custom Components
import { ItemContent } from "components/menu/ItemContent";
import { SearchBar } from "components/navbar/searchBar/SearchBar";
import { SidebarResponsive } from "components/sidebar/Sidebar";
import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
// Assets
import { apiurl } from "APIURL";
import navImage from "assets/img/layout/Navbar.png";
import axios from "axios";
import { IoMdMoon, IoMdSunny } from "react-icons/io";
import { MdDelete, MdInfoOutline, MdNotificationsNone } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getProfileData, setProfile, setUser } from "redux/slices/userSlice";
import routes from "routes";
import { Notification } from "types";

export default function HeaderLinks(props: { secondary: boolean }) {
  const [isTokenFound, setTokenFound] = useState(false);
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });

  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();
  // Chakra Color Mode
  const profile = useAppSelector(getProfileData);
  const navbarIcon = useColorModeValue("gray.400", "white");
  let menuBg = useColorModeValue("white", "navy.800");
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorBrand = useColorModeValue("brand.700", "brand.400");
  const ethColor = useColorModeValue("gray.700", "white");
  const borderColor = useColorModeValue("#E6ECFA", "rgba(135, 140, 189, 0.3)");
  const ethBg = useColorModeValue("secondaryGray.300", "navy.900");
  const ethBox = useColorModeValue("white", "navy.800");
  const dispatch = useAppDispatch();
  const history = useHistory();
  console.log(profile.name);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const shadow = useColorModeValue(
    "14px 17px 40px 4px rgba(112, 144, 176, 0.18)",
    "14px 17px 40px 4px rgba(112, 144, 176, 0.06)"
  );
  const borderButton = useColorModeValue("secondaryGray.500", "whiteAlpha.200");
  const logout = useCallback(() => {
    window.localStorage.removeItem("user");
    dispatch(setProfile(null));
    dispatch(setUser(null));
    history.push("/auth");
  }, []);

  const toast = useToast();
  useEffect(() => {
    show &&
      toast({
        title: notification.title,
        description: notification.body,
        status: "info",
        isClosable: true,
        duration: 5000,
      });
  });

  useEffect(
    () => {
      const getNotifs = async (id: string) => {
        setLoading(true);
        const res = await axios.get(`${apiurl}/notifications/${id}`);
        setNotifications(res.data);

        setLoading(false);
      };
      window.Notification.requestPermission().then((premission) => {
        if (premission === "granted") {
          getNotifs(profile.userId);
        } else {
          return;
        }
      });
    },
    /*()=>{
			const acceptPush =async (usrId:string) => {
				const res = await axios.post(`${apiurl}/notifications/${usrId}`,{
					deviceType:"gsdgjskd4",
					notificationToken:token
				})
				
			} 
			acceptPush(profile.userId)
			
		},*/

    [profile.userId]
  );

  return (
    <Flex
      w={{ sm: "100%", md: "auto" }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: "wrap", md: "nowrap" } : "unset"}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
    >
      <SearchBar
        mb={() => {
          if (secondary) {
            return { base: "10px", md: "unset" };
          }
          return "unset";
        }}
        me="10px"
        borderRadius="30px"
      />
      <Flex
        bg={ethBg}
        display={secondary ? "flex" : "none"}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        {/*
				<Flex align='center' justify='center' bg={ethBox} h='29px' w='29px' borderRadius='30px' me='7px'>
					<Icon color={ethColor} w='9px' h='14px' as={FaEthereum} />
				</Flex>
				<Text w='max-content' color={ethColor} fontSize='sm' fontWeight='700' me='6px'>
					1,924
					<Text as='span' display={{ base: 'none', md: 'unset' }}>
						{' '}
						DT
					</Text>
				</Text>
			*/}
      </Flex>
      <SidebarResponsive routes={routes} />
      <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdNotificationsNone}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: "30px", md: "unset" }}
          minW={{ base: "unset", md: "400px", xl: "450px" }}
          maxW={{ base: "360px", md: "unset" }}
        >
          <Flex w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notifications
            </Text>
            <Text
              fontSize="sm"
              fontWeight="500"
              color={textColorBrand}
              ms="auto"
              cursor="pointer"
            >
              Marquer tout lire
            </Text>
          </Flex>
          <Flex flexDirection="column" h={"50%"}>
            {loading === true ? (
              <Spinner />
            ) : (
              notifications.map((item) => (
                <MenuItem
                  _hover={{ bg: "none" }}
                  _focus={{ bg: "none" }}
                  px="0"
                  borderRadius="8px"
                  mb="10px"
                >
                  <Stack
                    direction="row"
                    w="full"
                    justifyContent={"space-between"}
                  >
                    <ItemContent
                      desc={
                        item.body +
                        " " +
                        new Date(item.createdAt).toLocaleString()
                      }
                      info={item.title}
                    />{" "}
                    <IconButton
                      aria-label=""
                      colorScheme={"brandScheme"}
                      icon={<MdDelete />}
                    />
                  </Stack>
                </MenuItem>
              ))
            )}
          </Flex>
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdInfoOutline}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          me={{ base: "30px", md: "unset" }}
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          minW={{ base: "unset" }}
          maxW={{ base: "360px", md: "unset" }}
        >
          <Image src={navImage} borderRadius="16px" mb="28px" />
          <Flex flexDirection="column">
            <Link w="100%" href="https://horizon-ui.com/pro">
              <Button w="100%" h="44px" mb="10px" variant="brand">
                Accès privilégié
              </Button>
            </Link>
            <Link w="100%" href="https://www.tunisietelecom.tn/Fr">
              <Button
                w="100%"
                h="44px"
                mb="10px"
                border="1px solid"
                bg="transparent"
                borderColor={borderButton}
              >
                Voir documentation
              </Button>
            </Link>
            <Link w="100%" href="https://www.tunisietelecom.tn/Fr">
              <Button
                w="100%"
                h="44px"
                variant="no-hover"
                color={textColor}
                bg="transparent"
              >
                Essayer gratuitement
              </Button>
            </Link>
          </Flex>
        </MenuList>
      </Menu>

      <Button
        variant="no-hover"
        bg="transparent"
        p="0px"
        minW="unset"
        minH="unset"
        h="18px"
        w="max-content"
        onClick={toggleColorMode}
      >
        <Icon
          me="10px"
          h="18px"
          w="18px"
          color={navbarIcon}
          as={colorMode === "light" ? IoMdMoon : IoMdSunny}
        />
      </Button>

      <Menu>
        <MenuButton p="0px">
          <Avatar
            src={profile.image}
            _hover={{ cursor: "pointer" }}
            color="white"
            name="Adela Parkson"
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
            children={
              <AvatarBadge
                boxSize="1.25em"
                bg={profile.status === "ONLINE" ? "green.500" : "tomato.400"}
              />
            }
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >
              👋&nbsp; bienvenue, {profile.name}
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              px="14px"
              onClick={() => history.push("/user/profile")}
            >
              <Text fontSize="sm">Paramètres du profil</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm"> Paramètres du Newsletter</Text>
            </MenuItem>
            <MenuItem
              as={Button}
              onClick={logout}
              _hover={{ bg: "none" }}
              _focus={{ bg: "none" }}
              color="red.400"
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Déconnecter</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
